export default __webpack_public_path__ + "static/media/achievement_switch_storyteller.3738c103.mp3";